/** biome-ignore-all lint/nursery/useImageSize: Size is defined */
/** biome-ignore-all lint/performance/noImgElement: Can't use next/image */

import { LoaderCircle } from "lucide-react";
import { QrCodeBorders } from "@/components/bank-id/components/pending-authentication/bank-id-authentication-elements/qr-code/qr-code-border";
import { QRCode } from "@/components/ui/qr-code";
import { useTranslations } from "@/hooks/use-translations";
import { useBankIdStore } from "@/stores/bank-id/bank-id-store";
import type { BankIdState } from "@/stores/bank-id/bank-id-store.types";

export function BankIdQrCode() {
  const { __ } = useTranslations();

  const qrCode = useBankIdStore((state: BankIdState) => state.qrCode);
  const isFetchingQrCode = useBankIdStore(
    (state: BankIdState) => state.isFetchingQrCode
  );

  return (
    <>
      <div
        className={
          "z-10 mt-4 block min-h-4xl rounded-xl bg-muted px-6 py-2 text-center dark:bg-foreground"
        }
      >
        {qrCode && (
          <div className={"relative mx-auto my-4 h-full w-2/3"}>
            <QrCodeBorders />

            <button className={"mx-auto h-full w-full"} type={"button"}>
              <QRCode
                className="sticky mx-auto h-full w-full p-4"
                data={qrCode}
                robustness={"H"}
              />
            </button>
          </div>
        )}
        {isFetchingQrCode && !qrCode && (
          <LoaderCircle className="mx-auto h-12 w-12 animate-spin text-black" />
        )}
      </div>

      {qrCode && (
        <div className={"mt-6 text-sm"}>
          <span>{__("bank_id.qr.open_app_scan_qr")}</span>
        </div>
      )}
    </>
  );
}
